// ----------------------------------------------------------------------

import { pxToRem } from '../../utils/getFontValue';

export default function CssBaseline() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          width: '100%',
          height: '100%',
          fontFamily: "'Poppins', sans-serif",
        },
        '#root': {
          width: '100%',
          height: '100%',
          '--swiper-theme-color': '#2cd095',
          '--swiper-navigation-size': pxToRem(24),
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        '::selection': {
          background: '#2cd095',
          color: '#000',
        },
      },
    },
  };
}
